import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';

import MarketValueHeader from '../../../../components/common/market-value-header';
import HeaderSwitch from '../../../../components/common/header-switch';
import { factory } from '../../positions/asset-header/asset-header-container';

import styles from './mm-instruments-asset-header.styles';

class MMInstrumentsAssetHeader extends PureComponent {

  static propTypes = {
    marketValue: PropTypes.number,
    dayChangeValue: PropTypes.number,
    dayChangePercent: PropTypes.number,
    currency: PropTypes.string,
    mmInstrumentsState: PropTypes.shape({
      selectedPositionType: PropTypes.string,
    }),
    mmInstrumentsView: PropTypes.shape({
      positionTypeOptions: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
      })),
    }),
    setSelectedPositionType: PropTypes.func,
  };

  constructor() {
    super();
    this.handleSwitchChanged = this.handleSwitchChanged.bind(this);
  }

  handleSwitchChanged(value) {
    this.props.setSelectedPositionType(value);
  }

  renderMarketValueElement() {
    const {
      marketValue,
      dayChangeValue,
      dayChangePercent,
      currency,
      messages,
      location
    } = this.props;

    return (
      <MarketValueHeader
        marketValue={marketValue}
        marketValueUnit={currency}
        dayChange={dayChangeValue}
        dayChangePercentage={dayChangePercent}
        dayChangeUnit={currency}
        messages={messages}
        location = {location}
      />
    );
  }

  renderSwitchElement() {
    const {
      mmInstrumentsState = {},
      mmInstrumentsView = {},
      depositsLength = 0,
      fundsLength = 0,
      messages,
    } = this.props;
    const { selectedPositionType } = mmInstrumentsState;
    const { positionTypeOptions = [] } = mmInstrumentsView;

    const optionsFilter = {
      deposits: depositsLength > 0,
      funds: fundsLength > 0,
    };
    const switchOptions = positionTypeOptions.filter(
      ({ value }) => optionsFilter[value]
    );

    return (
      <HeaderSwitch
        options={switchOptions}
        selected={selectedPositionType}
        onChange={this.handleSwitchChanged}
        messages={messages}
      />
    );
  }

  render() {
    return (
      <View testID="asset-header">
        <View style={styles.container}>
          {this.renderMarketValueElement()}
        </View>
        {this.renderSwitchElement()}
      </View>
    );
  }
}

export default factory({
  component: MMInstrumentsAssetHeader,
  assetDataFragmentExtend: {
    state: {
      selectedPositionType: true,
      setSelectedPositionType: { $set: 'selectedPositionType' },
    },
    assetsCommon: {
      static: {
        view: {
          positionType: {
            options: true,
          },
        },
      },
    },
    positions: {
      deposits: {
        length: true,
      },
      funds: {
        length: true,
      },
    },
  },
  mapperExtend: ({ assetData }) => ({
    setSelectedPositionType: assetData.state.setSelectedPositionType,
    mmInstrumentsView: {
      positionTypeOptions: assetData.assetsCommon.static.view.positionType.options,
    },
    mmInstrumentsState: {
      selectedPositionType: assetData.state.selectedPositionType,
    },
    depositsLength: assetData.positions.deposits.length,
    fundsLength: assetData.positions.funds.length,
  }),
});
